export default "__VITE_ASSET__DXlXfOrk__"